const Name = ({ text }) => {
  const base =
    'uppercase text-heading2CardsMobile md:text-heading2CardsDesktop text-olive font-chivoMono'

  return <span className={base}>{text}</span>
}

export default Name
